// @flow

import { handleError } from '@tectonics/alert-handler';

import gpayIconSrc from './images/gpay-intent.svg';
import phonePeIconSrc from './images/phonePe-intent.svg';
import paytmIconSrc from './images/paytm-intent.svg';

export function getAppImageSrc(appLink: any): string {
  const link = appLink.split(':');
  let appName = link[0];

  switch(appName) {
    case 'gpay':
    case 'tez':
      return gpayIconSrc;
    case 'phonepe':
      return phonePeIconSrc;
    case 'paytm':
      return paytmIconSrc;
    default: {
      handleError(new Error(`getAppImageSrc - there is no image source for "${appName}"`));
      return '';
    }
  }
}

export function getAppName(appLink: string): string {
  const link = appLink.split(':');
  return link[0];
}

export function getRedirectAppLink(appLinks: any, linkOtherApp: string): any {
  const appName = sessionStorage.getItem('appName');
  if (appName) {
    let appLink = '';
    switch(appName) {
      case 'gpay':
      case 'tez':
        appLink = appLinks[0];
        break;
      case 'phonepe':
        appLink = appLinks[1];
        break;
      case 'paytm':
        appLink = appLinks[2];
        break;
      case 'other-app':
        appLink = linkOtherApp;
        break;
    }

    sessionStorage.removeItem('appName');
    window.location = appLink;
  }
}
